module.exports = __webpack_public_path__ + "img/active.e1350b5.jpg";